var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "sidebar-left" } }, [
    _c("div", { staticClass: "h-100 d-flex flex-column" }, [
      _vm.activeStage.activeStep !== "select_output"
        ? _c(
            "div",
            { staticClass: "sidebar-top" },
            [
              _c("prompt-element"),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-item" }, [_c("styles")], 1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidebar-item" },
                [_c("inpainting-mode")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidebar-item" },
                [_c("inpainting-area")],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidebar-item" },
                [_c("advanced-settings-btn")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeStage.activeStep === "select_output"
        ? _c(
            "div",
            { staticClass: "sidebar-top" },
            [
              _c("div", { staticClass: "sidebar-item" }, [_c("export-btn")], 1),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-item" }, [_c("job-queued")], 1),
              _vm._v(" "),
              _c("select-output"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-bot btn-box" },
        [
          _vm.activeStage.activeStep !== "select_output"
            ? _c("generate-btn")
            : _vm._e(),
          _vm._v(" "),
          _vm.activeStage.activeStep === "select_output"
            ? _c("continue-btn")
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }